import NewAccounts from './NewAccounts';
import DepositAndRefunds from './DepositAndRefunds';
import Income from './Income';

export default {
  NewAccounts,
  DepositAndRefunds,
  Income,
};
